import * as discoverRoutines from './discoverRoutines';
import * as discoverSelectors from './discoverSelectors';
import * as rootSelectors from '../../selectors/root';
import * as toastRoutines from '../../sagas/routines/toastRoutines';
import { connect } from 'react-redux';
import { setActiveDiscover, setExpandedDiscover } from '../../redux/ui/actions';
import DiscoverTree from '../../Components/Discover/Tree/DiscoverTree';

function mapStateToProps(state) {
    return {
        activeDiscover: discoverSelectors.makeActiveDiscover(state),
        activeDiscoverId: rootSelectors.selectActiveDiscoverId(state),
        discoverOther: discoverSelectors.selectDiscoverOther(state),
        expandedDiscoverNodes: state.ui.expandedDiscoverNodes,
        orderedDiscoverOther: discoverSelectors.selectOrderedDiscoverOtherArray(state),
        orderedDiscoverTop: discoverSelectors.selectOrderedDiscoverTopArray(state),
        topCommonBackgroundImageURL: state.discover.topCommonBackgroundImageURL,
    };
}

const mapDispatchToProps = {
    createDiscover: discoverRoutines.createDiscover,
    moveNode: discoverRoutines.moveDiscoverNode,
    moveNodeToNewParent: discoverRoutines.moveNodeToNewParent,
    removeDiscover: discoverRoutines.removeDiscover,
    setActiveDiscover,
    setExpandedDiscover,
    setToastError: toastRoutines.setToastError,
    updateDiscover: discoverRoutines.updateDiscover,
    updateDiscoverTreeBackground: discoverRoutines.updateDiscoverTreeBackground,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DiscoverTree);
